import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120" {...props}><path d="M120 57.95V0H62.05zM0 120h62.19L0 57.81z" /><path d="M44.61 60l17.6 17.6-32.59 32.59-17.6-17.6zm45.05-46.53l17.6 17.6-32.58 32.59-17.6-17.6z" /></svg>);